module.exports = __webpack_public_path__ + "static/media/roqqett-logo.42a4b0a7.jpg";